import Vue from 'vue'
import App from './App.vue'
Vue.config.productionTip = false

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);
import router from './router'
import 'normalize.css/normalize.css'
// import store from './store'
import scroll from 'vue-seamless-scroll'
Vue.use(scroll)

import 'wowjs/css/libs/animate.css'
import wow from 'wowjs'
Vue.prototype.$wow = wow

import service from './utils/service'  //全局工具-网络请求
import message from './utils/message'
import LocalCache from './utils/catch/cache'

Vue.prototype.$service = service;
Vue.prototype.$message = message;
Vue.prototype.$cache = LocalCache;

import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/antd.css';
Vue.config.productionTip = false;
Vue.use(Antd);


import BaiduMap from 'vue-baidu-map'
Vue.use(BaiduMap, {
  ak: 'cXF7ryuZSRuWbx9fXBwugtyzC9GfeIHK'  //  在此输入你自己的百度地图ak
})
import VueAMap from "vue-amap";
Vue.use(VueAMap);
// 初始化vue-amap
VueAMap.initAMapApiLoader({
  key: "731ac04c6e6e7bf4f72a10ce223f51b5", // 这里写你申请的高德地图的key
  plugin: ["AMap.Autocomplete", "AMap.Geocoder", "AMap.Geolocation"],
  v: "1.4.15",
  uiVersion: "1.1",
});

import SignCanvas from "sign-canvas";

Vue.use(SignCanvas);

new Vue({
	router,
	render: h => h(App),
}).$mount('#app')
